import { createGlobalStyle } from "styled-components";

export const theme = {
  bg: "#0b0d12",
  surface: "#141821",
  surfaceAlt: "#1b202c",
  border: "#262c3a",
  text: "#c9d0de",
  textMuted: "#8a93a6",
  heading: "#ffffff",
  accent: "#ff5a3c",
  accentHover: "#ff7d5c",
};

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }


    html {
        scroll-behavior: smooth;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: ${theme.bg};
        color: ${theme.text};
        overflow-x: hidden;
    }

    ::selection {
        background: ${theme.accent};
        color: #fff;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: ${theme.surfaceAlt};
        color: ${theme.text};
        transition: all 0.3s ease-in-out;
        outline: none;
        width: 100%;

        :focus-within {
            background: none;
            box-shadow: ${theme.accent} 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: ${theme.heading};
        font-size: 44px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 36px;
        }

        @media only screen and (max-width: 414px) {
          font-size: 28px;
        }
    }

    p {
        color: ${theme.text};
        font-size: 17px;
        line-height: 1.65;
    }

    h1 {
        font-weight: 600;
    }

    h3.MuiTypography-root,
    h4.MuiTypography-root,
    h5.MuiTypography-root,
    h6.MuiTypography-root {
        font-family: 'Motiva Sans Bold', serif;
        color: ${theme.heading};
    }

    h3.MuiTypography-root,
    h4.MuiTypography-root {
        font-size: 28px;
    }

    .MuiTypography-body1 {
        font-family: 'Motiva Sans Light', sans-serif;
        line-height: 1.7;
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${theme.accent};
        transition: color 0.2s ease-in-out;

        :hover {
            color: ${theme.accentHover};
        }
    }

    a:focus-visible,
    button:focus-visible {
        outline: 2px solid ${theme.accent};
        outline-offset: 2px;
    }

    img {
        max-width: 100%;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }
`;
